import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { LoginService } from '../services/login.service';
import { ToastService } from '../services/toast.service';
import { environment } from '../../environments/environment';

/** Rotas que não usam a base do cliente: login/segurança (auth) e cadastro de ambientes (registry). */
const SEM_AMBIENTE = ['/auth/', '/environments/'];

/**
 * Rotas públicas do auth: não levam o token (um token vencido no navegador seria recusado) e um 401 delas não
 * derruba a sessão. A do link de senha é aberta a partir do e-mail, às vezes com outra sessão no navegador.
 */
const PUBLICAS = ['/auth/login', '/auth/redefinicao-senha'];

export const httpHeaderInterceptor: HttpInterceptorFn = (req, next) => {
    const login = inject(LoginService);
    const router = inject(Router);
    const toast = inject(ToastService);
    const isPublica = ehPublica(req.url);
    const token = login.getToken();
    const headers: Record<string, string> = {};
    if (token && !isPublica) headers['Authorization'] = `Bearer ${token}`;

    // Toda chamada à API de dados leva a chave do ambiente (base do cliente) selecionado
    const chave = login.getClientSecretKey();
    if (chave && usaAmbiente(req.url)) headers['client-secret-key'] = chave;

    const request = Object.keys(headers).length ? req.clone({ setHeaders: headers }) : req;
    return next(request).pipe(catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !isPublica) {
            login.logout();
            router.navigate(['/auth/login'], { queryParams: { returnUrl: router.url } });
        } else if (error.status === 403 && login.isAutenticado()) {
            toast.erro('Acesso negado', error.error?.message || 'Você não tem permissão para acessar este recurso.');
        }
        return throwError(() => error);
    }));
};

function ehPublica(url: string): boolean {
    if (!url.startsWith(environment.apiUrl)) return false;
    const caminho = url.substring(environment.apiUrl.length);
    return PUBLICAS.some(rota => caminho === rota || caminho.startsWith(rota + '/'));
}

function usaAmbiente(url: string): boolean {
    if (!url.startsWith(environment.apiUrl)) return false;
    const caminho = url.substring(environment.apiUrl.length);
    return !SEM_AMBIENTE.some(prefixo => caminho.startsWith(prefixo));
}
